import { render } from "./ValidationDeleteDialog.vue?vue&type=template&id=cb32142a"
import script from "./ValidationDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ValidationDeleteDialog.vue?vue&type=script&lang=js"

import "./ValidationDeleteDialog.vue?vue&type=style&index=0&id=cb32142a&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});qInstall(script, 'directives', {ClosePopup});
